const componentsComboboxDeviceComboboxEn = {
  noDevicesFound: 'No devices found',
  searchDevicePlaceholder: 'Search device name or device tag'
};
export default componentsComboboxDeviceComboboxEn;